import React, {Component} from 'react';
import {Link, Switch, Route } from 'react-router-dom';
import {withRouter} from 'react-router';

import { connect } from 'react-redux'

import { userLogout } from '../../../actions/global';
import { setMessage } from '../../../actions/message';


class Logout extends Component {

  componentDidMount() {
      this.props.setMessage({type: 'danger', message: 'Succesvol uitgelogd.'});
      this.props.userLogout();
      this.props.history.push('/');
  }

  render() {   
    return (
      <div>
        Logout!
      </div>
      )
  }
}
 
function mapStateToProps(state, ownProps) {
 
    return {
        user: state.UserReducer    
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        userLogout: () => dispatch(userLogout()),
        setMessage: (messageObject) => dispatch(setMessage(messageObject))
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Logout))



// WEBPACK FOOTER //
// ./src/components/Account/Logout/index.js